import { render, staticRenderFns } from "./StudentMypage.vue?vue&type=template&id=f2e4b1a4&scoped=true&"
import script from "./StudentMypage.vue?vue&type=script&lang=js&"
export * from "./StudentMypage.vue?vue&type=script&lang=js&"
import style0 from "./StudentMypage.vue?vue&type=style&index=0&id=f2e4b1a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e4b1a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
